<template>
	<div>
		<van-empty :description="message" />
		<div style="text-align: center; font-size: 12px;color: #999;">
<!--			<p style="margin:0;">备案信息 <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备19037237号-9</a></p>-->
			<!-- <p style="margin:0;display: flex;align-items: center;justify-content: center;">本网站由 <a href="https://www.upyun.com/?utm_source=lianmeng&utm_medium=referral" target="_blank"><img src="/static/upyun_logo2.png" width="40px" height="20px" /></a>提供CDN加速/云存储服务</p> -->
		</div>
	</div>
</template>

<script>

export default {
	name: 'Page404',
	data(){
		return {
			message:'页面 404'
		}
	},
	created(){
		if(this.$route.params && this.$route.params.message) {
			this.message = this.$route.params.message;
		}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/404.vue